export default {
  title: {
    changeEmailRequest: 'Change Email Request',
    bindEmailRequest: 'Email Connect Request'
  },
  label: {
    currentEmail: 'Current Email',
    newEmail: 'New Email',
    password: 'Password'
  },
  message: {
    youAreUsingTheEmail: 'This is the e-mail you are currently using',
    requestSuccess: 'You have requested for changing your email address successfully, please check your new email box to go on.'
  }
}
